import type { Ref, SVGProps } from "react"
import { forwardRef, memo } from "react"

interface SVGRProps {
    title?: string
    titleId?: string
}
const SvgChevronDown = (
    { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
    ref: Ref<SVGSVGElement>,
) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 10 6"
        role="img"
        ref={ref}
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#000"
            fillOpacity={0.85}
            d="M5 5.466q-.384 0-.71-.32l-3.08-3.15a.9.9 0 0 1-.18-.264.8.8 0 0 1-.055-.312.85.85 0 0 1 .414-.73.8.8 0 0 1 .42-.116q.35 0 .623.278L5.15 3.663h-.291L7.568.852a.826.826 0 0 1 1.337.145q.115.193.115.423 0 .342-.239.577L5.705 5.146a1.2 1.2 0 0 1-.338.243.9.9 0 0 1-.367.077"
        />
    </svg>
)
const ForwardRef = forwardRef(SvgChevronDown)
const Memo = memo(ForwardRef)
export default Memo
